const isLazyFrame = document.getElementsByClassName("lazyframe");
if (isLazyFrame.length > 0) {
  let elements = document.querySelectorAll(".lazyframe");
  lazyframe(elements);
}
